import { Injectable } from '@angular/core';
import { FirebaseCrashlytics } from '@capacitor-firebase/crashlytics';

@Injectable({
  providedIn: 'root'
})
export class CrashlyticsService {

  constructor() { }

  async enableCrashlytics() {
    await FirebaseCrashlytics.setEnabled({ enabled: true });
  }

  async testCrash(message) {
    await FirebaseCrashlytics.crash({ message: message });
  }
  
  async setCustomKeyCrash(key, value, type) {
    await FirebaseCrashlytics.setCustomKey({
      key: key,
      value: value,
      type: type,
    });
  }
  
  async recordException(message) {
    await FirebaseCrashlytics.recordException({
      message: message,
    });
  }

}
